export enum ClusterSpecialPaymentType {
  RegionalHr = 'HR Regional',
  Level1 = 'N-1',
  Level2 = 'N-2'
}
